import React from "react";
import Container from "react-bootstrap/Container";
import { getTrayectosSorted } from "../../utils/curriculumMalla";

function MallaLegend({ meta, title = "Trayectos formativos" }) {
  const trayectos = getTrayectosSorted(meta);

  return (
    <section className="course-detail__legend" aria-label={title}>
      <Container fluid>
        <p className="course-detail__legend__title">{title}</p>
        <ul className="course-detail__legend__list">
          {trayectos.map((t) => (
            <li key={t.id}>
              <span
                className="course-detail__legend__swatch"
                style={{ backgroundColor: t.color }}
                aria-hidden="true"
              />
              <span>{t.label}</span>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}

export default MallaLegend;
